// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import VueResource from 'vue-resource';
// import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
import '@/theme/index.css'
Vue.use(router);
Vue.use(VueResource);
Vue.use(ElementUI)

Vue.config.productionTip = false

Date.prototype.Format = function(fmt) {
	var o = {
		"M+": this.getMonth() + 1,
		"d+": this.getDate(),
		"H+": this.getHours(),
		"m+": this.getMinutes(),
		"s+": this.getSeconds(),
		"S+": this.getMilliseconds()
	};

	//因位date.getFullYear()出来的结果是number类型的,所以为了让结果变成字符串型，下面有两种方法：


	if (/(y+)/.test(fmt)) {
		//第一种：利用字符串连接符“+”给date.getFullYear()+""，加一个空字符串便可以将number类型转换成字符串。

		fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(fmt)) {

			//第二种：使用String()类型进行强制数据类型转换String(date.getFullYear())，这种更容易理解。

			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(String(o[k]).length)));
		}
	}
	return fmt;
}

router.beforeEach((to, from, next) => {
	var userInfo = store.getters.getUserInfo;
	if(to.name == "login" || to.name == "forgetpassword" || to.name == "register"){
		next();
		return;
	}
	if(userInfo==null){
		router.replace({name:"login"});
	}else{
		next();
	}
});

// Vue.http.interceptors.push((request, next) => {
// 	request.credentials = true;
// 	next((response) => {
// 		var result = response.body;
// 		//用户token失效
// 		if(result.ecode == -101){
// 			window.location = "/";
// 		}else{
// 			return response;
// 		}
// 	});
// });

/* eslint-disable no-new */
new Vue({
  el: '#app',
	router:router,
	store:store,
  components: { App },
  template: '<App/>',
  mode: 'history'
})

Vue.prototype.responseDefaultHandle = function(response){
	var code = response.data.ecode;
	//未登录
	if(code == -101 ){
		var _this = this;
		this.$alert(response.data.emsg, '提示', {
			confirmButtonText: '确定',
			callback:function () {
				_this.$router.replace({name:"login"});
			}
		});
		return false;
	}
	return true;
}



// WEBPACK FOOTER //
// ./src/main.js